import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@beamery/lib-ds-components';
import { cloneElement } from 'react';
import { HeaderFive, HeaderFour, HeaderOne, HeaderThree, HeaderTwo, } from '../components/headers';
import { OrderedList } from '../components/ordered-list';
import { UnorderedList } from '../components/unordered-list';
import { StyledParagraph } from '../components/text';
import { isLink } from '../rich-text.interface';
const blockRenderMap = {
    'header-one': _jsx(HeaderOne, {}),
    'header-two': _jsx(HeaderTwo, {}),
    'header-three': _jsx(HeaderThree, {}),
    'header-four': _jsx(HeaderFour, {}),
    'header-five': _jsx(HeaderFive, {}),
    'unordered-list': _jsx(UnorderedList, {}),
    'ordered-list': _jsx(OrderedList, {}),
    'unordered-list-item': _jsx("li", {}),
    'ordered-list-item': _jsx("li", {}),
    link: (element) => isLink(element) ? _jsx(Link, { setting: 'inline', href: element.url }) : _jsx("span", {}),
    default: _jsx(StyledParagraph, {}),
};
export const RenderElement = ({ element, children }) => {
    var _a;
    const renderer = (_a = blockRenderMap[element.type]) !== null && _a !== void 0 ? _a : blockRenderMap.default;
    if (typeof renderer === 'function') {
        return cloneElement(renderer(element), {
            children,
        });
    }
    return cloneElement(renderer, {
        children,
    });
};
